function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import classNames from "classnames";
import UserSidemenu from "../SideMenu/UserSidemenu";
import isToday from "date-fns/isToday";
import isYesterday from "date-fns/isYesterday";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { MdRefresh } from "react-icons/md";
import { HiDownload, HiOutlineClock, HiOutlineExclamationCircle } from "react-icons/hi";
import { useQuery, useLazyQuery } from "@apollo/client";
var moment = require("moment-timezone");
import { APPS_AND_WEBSITE_HISTORY_QUERY, USER_DETAILS_QUERY, Export_APPS_AND_WEBSITE_HISTORY_QUERY } from "./query";
import { FilterContext, UserContext } from "../index";
import Loader from "./../Loader/Loader";
import "./AppsAndWebsitesHistory.css";
import Popover from "react-bootstrap/Popover";
import DatePicker from "react-datepicker";
import "../css/react-datepicker.css";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
var AppsAndWebsitesHistory = function AppsAndWebsitesHistory(props) {
  var _match$params, _userDetailsData$user, _appsAndWebsitesHisto, _appsAndWebsitesHisto2;
  var _React$useContext = React.useContext(FilterContext),
    organisationId = _React$useContext.organisationId,
    teamId = _React$useContext.teamId,
    startDate = _React$useContext.startDate,
    endDate = _React$useContext.endDate,
    organisationBilling = _React$useContext.organisationBilling,
    organisationSettings = _React$useContext.organisationSettings,
    from = _React$useContext.from,
    role = _React$useContext.role,
    organisationStatus = _React$useContext.organisationStatus;
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;
  var match = props.match;
  var LIMIT = 25;

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);
  React.useEffect(function () {
    if (from == "web" && role == "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if (((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") && role != "Member" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);

  // load more state
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isAllLoaded = _React$useState2[0],
    setIsAllLoaded = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    exportStartDate = _React$useState4[0],
    setExportStartDate = _React$useState4[1];
  var _React$useState5 = React.useState([]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    csvDatas = _React$useState6[0],
    setCsvDatas = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    exportButton = _React$useState8[0],
    setExportButton = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    triggerOpen = _React$useState10[0],
    setTriggerOpen = _React$useState10[1];
  var url = (_match$params = match.params) === null || _match$params === void 0 ? void 0 : _match$params.url;
  React.useEffect(function () {
    setIsAllLoaded(false);
    setCsvDatas([]);
  }, [url, startDate, endDate, teamId]);
  React.useEffect(function () {
    var todayDate = null;
    setCsvDatas(false);
    setExportStartDate(todayDate);
    setExportButton(false);
    setTriggerOpen(false);
  }, [url]);
  var _useQuery = useQuery(USER_DETAILS_QUERY, {
      variables: {
        url: url
      },
      skip: !url
    }),
    userDetailsData = _useQuery.data;
  var _useQuery2 = useQuery(APPS_AND_WEBSITE_HISTORY_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userId: url ? null : user.userId,
        url: url ? url : null,
        startDate: Number(moment(startDate).format("x")),
        endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
        limit: LIMIT,
        offset: 0,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
      },
      skip: !organisationId || !teamId
    }),
    appsAndWebsitesHistoryData = _useQuery2.data,
    appsAndWebsitesHistoryError = _useQuery2.error,
    appsAndWebsitesHistoryLoading = _useQuery2.loading,
    fetchMore = _useQuery2.fetchMore,
    networkStatus = _useQuery2.networkStatus,
    refetch = _useQuery2.refetch;
  var _useLazyQuery = useLazyQuery(Export_APPS_AND_WEBSITE_HISTORY_QUERY, {
      // A rate-limited export (429) never returns data, and exportButton is
      // cleared on the data path only - without this the export button stays
      // loading until the page is reloaded. The message itself is shown by the
      // errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
      }
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getExport = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    exportLoading = _useLazyQuery2$.loading,
    exportData = _useLazyQuery2$.data;
  var csvData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var dataArray, dataValues, fileType, fileExtension, fileName, ws, wb, excelBuffer, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dataArray = [];
          dataValues = exportData === null || exportData === void 0 ? void 0 : exportData.exportAppsAndWebsiteHistory;
          if (dataValues) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", []);
        case 4:
          dataValues.map(function (appsAndWebsiteValue, index) {
            var t = {
              displayName: appsAndWebsiteValue.user.displayName.toString(),
              emailId: appsAndWebsiteValue.user.emailId,
              app: appsAndWebsiteValue.viewType === "app" ? appsAndWebsiteValue.title : appsAndWebsiteValue.windowTitle ? appsAndWebsiteValue.windowTitle : appsAndWebsiteValue.title,
              time: moment(Number(appsAndWebsiteValue.addedAt)).format("D MMMM YYYY, hh:mm a"),
              status: appsAndWebsiteValue.productivityStatus,
              duration: appsAndWebsiteValue.totalSec
            };
            return dataArray.push(t);
          });
          fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
          fileExtension = ".xlsx";
          fileName = "workfolio-apps-history-".concat(moment(Number(exportStartDate)).format("DD-MMM"));
          ws = XLSX.utils.json_to_sheet(dataArray);
          wb = {
            Sheets: {
              data: ws
            },
            SheetNames: ["data"]
          };
          excelBuffer = XLSX.write(wb, {
            bookType: "xlsx",
            type: "array"
          });
          data = new Blob([excelBuffer], {
            type: fileType
          });
          FileSaver.saveAs(data, fileName + fileExtension);
          setCsvDatas(dataArray);
          setExportButton(false);
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [exportData]);
  React.useEffect(function () {
    csvData();
  }, [exportData]);
  React.useEffect(function () {
    refetch === null || refetch === void 0 ? void 0 : refetch();
  }, [props.location.key]);
  var csvHeader = React.useMemo(function () {
    var dataValues = exportData === null || exportData === void 0 ? void 0 : exportData.exportAppsAndWebsiteHistory;
    if (!dataValues) {
      return [];
    }
    var headers = [{
      displayName: "Employee Name",
      id: "displayName"
    }, {
      displayName: "Email Id",
      id: "emailId"
    }, {
      displayName: "Used App/Site",
      id: "app"
    }, {
      displayName: "Visited Time",
      id: "time"
    }, {
      displayName: "Duration",
      id: "duration"
    }, {
      displayName: "Productive Status",
      id: "status"
    }];
    return headers;
  }, [exportData]);
  if (appsAndWebsitesHistoryLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (appsAndWebsitesHistoryError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  if (!appsAndWebsitesHistoryData) {
    return null;
  }
  if (appsAndWebsitesHistoryData.appsAndWebsiteHistory.length < LIMIT && !isAllLoaded) {
    setIsAllLoaded(true);
  }

  //onScroll={(e)=>console.log('SCROLL!!',e)}

  var handleLoadMore = function handleLoadMore() {
    if (appsAndWebsitesHistoryLoading) return;
    fetchMore({
      variables: {
        offset: appsAndWebsitesHistoryData.appsAndWebsiteHistory.length
      },
      updateQuery: function updateQuery(prev, _ref2) {
        var fetchMoreResult = _ref2.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if (fetchMoreResult.appsAndWebsiteHistory.length < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        return _objectSpread(_objectSpread({}, prev), {}, {
          appsAndWebsiteHistory: [].concat(_toConsumableArray(prev.appsAndWebsiteHistory), _toConsumableArray(fetchMoreResult.appsAndWebsiteHistory))
        });
      }
    });
  };
  var handleDateChange = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(date) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setExportStartDate(date);
            getExportData(date);
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleDateChange(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var getExportData = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(date) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            setExportButton(true);
            setTriggerOpen(false);
            getExport({
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                userId: url ? null : user.userId,
                url: url ? url : null,
                startDate: Number(moment(date).format("x")),
                endDate: Number(moment(date).format("x")),
                timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
              }
            });
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function getExportData(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  // console.log("exportStartDate", exportStartDate);
  // console.log("csvData", csvDatas);

  return /*#__PURE__*/React.createElement("div", {
    className: "apps-and-websites-history-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "apps-and-websites-history-card-export"
  }, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export app usage")
  }, /*#__PURE__*/React.createElement("div", {
    className: "timesheet-export-button-header disable-timesheet"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "timesheet-download-icon"
  }), " Export App Usage")) : (appsAndWebsitesHistoryData === null || appsAndWebsitesHistoryData === void 0 ? void 0 : appsAndWebsitesHistoryData.appsAndWebsiteHistory.length) === 0 ? /*#__PURE__*/React.createElement("div", {
    className: "timesheet-export-button-header disable-timesheet"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "timesheet-download-icon"
  }), "Export App Usage") : /*#__PURE__*/React.createElement(OverlayTrigger, {
    trigger: "click",
    show: triggerOpen,
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Popover, {
      className: "page-content-wrapper-menu-filter-overlay-trigger"
    }, /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "page-content-wrapper-menu-filter-overlay"
    }, /*#__PURE__*/React.createElement("div", {
      className: "app-page-content-wrapper-menu-filter-overlay-datepicker"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      inline: true,
      selected: exportStartDate,
      onChange: handleDateChange,
      startDate: exportStartDate,
      maxDate: moment().toDate()
    }))))))
  }, !exportButton ? /*#__PURE__*/React.createElement("div", {
    className: "timesheet-export-button-header enable-timesheet",
    onClick: function onClick() {
      return setTriggerOpen(triggerOpen ? false : true);
    }
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "timesheet-download-icon"
  }), "Export App Usage") : /*#__PURE__*/React.createElement("div", {
    className: "timesheet-export-button-header disable-timesheet"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "timesheet-download-icon"
  }), "Downloading"))), /*#__PURE__*/React.createElement("div", {
    className: "apps-and-websites-history-card-content"
  }, !url ? /*#__PURE__*/React.createElement("p", {
    className: "apps-and-websites-history-card-title"
  }, "All users app usage history") : /*#__PURE__*/React.createElement("p", {
    className: "apps-and-websites-history-card-title"
  }, userDetailsData === null || userDetailsData === void 0 ? void 0 : (_userDetailsData$user = userDetailsData.userDetailsData) === null || _userDetailsData$user === void 0 ? void 0 : _userDetailsData$user.displayName, "'s app usage history"), ((_appsAndWebsitesHisto = appsAndWebsitesHistoryData.appsAndWebsiteHistory) === null || _appsAndWebsitesHisto === void 0 ? void 0 : _appsAndWebsitesHisto.length) != 0 ? /*#__PURE__*/React.createElement(VerticalTimeline, {
    style: {
      height: "100vh"
    }
  }, (_appsAndWebsitesHisto2 = appsAndWebsitesHistoryData.appsAndWebsiteHistory) === null || _appsAndWebsitesHisto2 === void 0 ? void 0 : _appsAndWebsitesHisto2.map(function (appsAndWebsiteValue, key) {
    return /*#__PURE__*/React.createElement(VerticalTimelineElement, {
      className: "vertical-timeline-element--work",
      contentStyle: {
        background: "#fff",
        color: "rgb(73 80 87/69%)"
      },
      contentArrowStyle: {
        borderRight: "7px solid  #fff"
      },
      date: moment().tz(organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone).format("MMM DD YYYY") == moment(Number(appsAndWebsiteValue.addedAt)).tz(organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone).format("MMM DD YYYY") ? "Today ".concat(moment(Number(appsAndWebsiteValue.addedAt)).format("hh:mm A")) : moment().subtract(1, "days").tz(organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone).format("MMM DD YYYY") == moment(Number(appsAndWebsiteValue.addedAt)).tz(organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone).format("MMM DD YYYY") ? "Yesterday ".concat(moment(Number(appsAndWebsiteValue.addedAt)).format("hh:mm A")) : "".concat(moment(Number(appsAndWebsiteValue.addedAt)).format("D MMMM YYYY, hh:mm a"))

      // isToday(Number(appsAndWebsiteValue.addedAt))
      //   ? `Today ${moment(Number(appsAndWebsiteValue.addedAt)).format("hh:mm A")}`
      //   : isYesterday(Number(appsAndWebsiteValue.addedAt))
      //   ? `Yesterday ${moment(Number(appsAndWebsiteValue.addedAt)).format("hh:mm A")}`
      //   : //: format(Number(appsAndWebsiteValue.addedAt), "d LLL, yyyy hh:mm A")
      //     `${moment(Number(appsAndWebsiteValue.addedAt)).format("D MMMM YYYY, hh:mm a")}`
      ,
      iconStyle: {
        background: "rgb(252 252 252)",
        color: "#bdbdbd"
      },
      icon: /*#__PURE__*/React.createElement(HiOutlineClock, {
        className: "website-app-icon"
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "apps-and-websites-history-card-table-title-section"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: appsAndWebsiteValue.icon,
      className: "app-profile-avatar"
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(OverlayTrigger, {
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-team-name"
      }, appsAndWebsiteValue.viewType === "app" ? appsAndWebsiteValue.title : appsAndWebsiteValue.windowTitle ? appsAndWebsiteValue.windowTitle : appsAndWebsiteValue.title)
    }, /*#__PURE__*/React.createElement("div", {
      className: "apps-and-websites-history-card-table-title"
    }, appsAndWebsiteValue.viewType === "app" ? appsAndWebsiteValue.title : appsAndWebsiteValue.windowTitle ? appsAndWebsiteValue.windowTitle : appsAndWebsiteValue.title)), /*#__PURE__*/React.createElement("div", {
      className: "app-website-whole-div"
    }, !url ? /*#__PURE__*/React.createElement("div", {
      className: "app-website-user-header"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-team-name"
      }, appsAndWebsiteValue.user.displayName)
    }, /*#__PURE__*/React.createElement("p", {
      className: "count-tooltip-user-content-app"
    }, appsAndWebsiteValue.user.displayName))) : null, /*#__PURE__*/React.createElement("div", {
      className: "app-website-sub-div1"
    }, /*#__PURE__*/React.createElement(HiOutlineClock, {
      className: "app-website-sub-div1-icon"
    }), /*#__PURE__*/React.createElement("p", {
      className: "app-website-sub-div-value-hours"
    }, appsAndWebsiteValue.totalSec)), /*#__PURE__*/React.createElement("div", {
      className: "app-website-sub-div"
    }, /*#__PURE__*/React.createElement(HiOutlineExclamationCircle, {
      className: classNames("app-website-sub-div-icon", appsAndWebsiteValue.productivityStatus)
    }), /*#__PURE__*/React.createElement("p", {
      className: classNames("app-website-sub-div-value-status", appsAndWebsiteValue.productivityStatus)
    }, appsAndWebsiteValue.productivityStatus))))));
  }), !isAllLoaded ? /*#__PURE__*/React.createElement(VerticalTimelineElement, {
    className: "vertical-timeline-element--work",
    iconStyle: {
      background: "rgb(252 252 252)",
      color: "#266dfb",
      marginTop: "-3px",
      cursor: "pointer"
    },
    icon: /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "count",
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-top"
      }, "Load more")
    }, /*#__PURE__*/React.createElement(MdRefresh, {
      className: "website-app-icon"
    })),
    iconOnClick: handleLoadMore
  }) : /*#__PURE__*/React.createElement(VerticalTimelineElement, {
    className: "vertical-timeline-element--work",
    iconStyle: {
      background: "rgb(252 252 252)",
      color: "rgb(131 148 171)",
      marginTop: "-3px"
    },
    icon: /*#__PURE__*/React.createElement("div", {
      className: "apps-website-end-text"
    }, "End")
  })) : /*#__PURE__*/React.createElement("div", {
    className: "no-data"
  }, "No data found")));
};
var AppsAndWebsitesHistoryWrapper = function AppsAndWebsitesHistoryWrapper(props) {
  return /*#__PURE__*/React.createElement(UserSidemenu, {
    disableTeamView: true,
    history: props.history,
    match: props.match
  }, function (user) {
    return /*#__PURE__*/React.createElement(AppsAndWebsitesHistory, _extends({
      user: user
    }, props));
  });
};
export default AppsAndWebsitesHistoryWrapper;